import { useTranslation } from 'react-i18next'
import { acceptTermsAndConditions } from 'app/dashboard/state/actions'
import { useNotifier } from '@cbgms/base/notifier'
import { SetupWizardStep, SetupWizardStepComponent } from 'app/menu/components/TopBarV1/setupWizard/SetupWizardStep'
import { useDispatch } from 'react-redux'
import { generateSubmissionError } from 'utils/Form/SubmissionError'
import { useGetTermsAndConditionsUrl } from 'utils/use-get-terms-and-conditions-url'
import GradingIcon from '@mui/icons-material/Grading'

export const AcceptTermsAndConditionsCTA: SetupWizardStepComponent = props => {
  const { t } = useTranslation()
  const termsAndConditionsUrl = useGetTermsAndConditionsUrl()
  const notifier = useNotifier()
  const dispatch = useDispatch()

  return (
    <SetupWizardStep
      {...props}
      step={{
        icon: <GradingIcon />,
        content: (
          <>
            {t('SetupWizard.TermsAndConditions')}{' '}
            <a href={termsAndConditionsUrl} target='_blank' rel='nofollow'>
              {t('global.termsAndConditions')}
            </a>
          </>
        ),
        buttonText: t('SetupWizard.TermsAndConditionsCTA'),
        actionOnClick: async () => {
          try {
            await dispatch(acceptTermsAndConditions())
            props.refetch()
            notifier.success(t('SetupWizard.TermsAndConditionsSuccess'))
          } catch (error) {
            throw generateSubmissionError(error)
          }
        }
      }}
    />
  )
}
